import {Injectable} from '@angular/core';
import {
  Configurator,
  OccConfigurator,
  OccConfiguratorVariantSerializer,
} from '@spartacus/product-configurator/rulebased';
import {DcpUiType} from '../models';

@Injectable({providedIn: 'root'})
export class DcpOccConfiguratorVariantSerializer extends OccConfiguratorVariantSerializer {
  override convertAttribute(attribute: Configurator.Attribute, occAttributes: OccConfigurator.Attribute[]): void {
    super.convertAttribute(attribute, occAttributes);
    const attributeJustAdded = occAttributes[occAttributes.length - 1];
    if (attribute.dcpUiType === DcpUiType.QUANTITY) {
      // Treat as UiType.NUMERIC
      attributeJustAdded.formattedValue = attribute.userInput;
      attributeJustAdded.type = OccConfigurator.UiType.NUMERIC;
    }
    if (attribute.dcpUiType === DcpUiType.DATE) {
      // Treat as UiType.STRING
      attributeJustAdded.value = attribute.userInput;
      attributeJustAdded.type = OccConfigurator.UiType.STRING;
    }
  }
}
